import React from "react";
import createSvgIcon from "@material-ui/core/utils/createSvgIcon";

/**
 * author: Michael Irigoyen
 * id 54AC2207-9F8D-4A1D-B8B4-ED626D0C8C38
 * name hydraulic-oil-temperature
 * version: 4.9.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/hydraulic-oil-temperature.svg
 * tags
 * - Automotive 
 */
export const HydraulicOilTemperatureIcon = createSvgIcon(<><path d="M9 18C7.34 18 6 16.66 6 15C6 13 9 9.63 9 9.63S12 13 12 15C12 16.66 10.66 18 9 18M14 4V20H4V4H2V20C2 21.11 2.89 22 4 22H14C15.11 22 16 21.11 16 20V4H14M10 6V2H8V6H5V8H13V6H10M21 17.5V5.5C21 4.67 20.33 4 19.5 4S18 4.67 18 5.5V17.5C17.37 17.97 17 18.71 17 19.5C17 20.88 18.12 22 19.5 22S22 20.88 22 19.5C22 18.71 21.63 18 21 17.5M20 13H19V6H20V13Z" /></>, 'HydraulicOilTemperatureIcon');
export default HydraulicOilTemperatureIcon